import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import React from "react";


const ChangesModal = (props: {show: boolean, setShow: (value: boolean) => void}) => {
    return (
        <Modal
            show={props.show}
            onHide={() => props.setShow(false)}
            size={"sm"}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Avbryt</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Är du säker på att du vill avbryta?</p>
                Dina ändringar kommer inte att sparas.
            </Modal.Body>
            <Modal.Footer>
                <Button variant={'secondary'} onClick={() => props.setShow(false)}>Avbryt</Button>
                <Button variant={'danger'} onClick={() => props.setShow(true)}>Ja</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ChangesModal